module.exports = __webpack_public_path__ + "img/tickets.ed7a2538.svg";